<template>
  <div id="ContainerDialog">
    <el-dialog
      :visible.sync="isOpen"
      fullscreen
      :before-close="handleClose"
      :show-close="false"
      class="cs-dialog"
    >
      <div
        class="relative"
        style="background-color: #dedede"
        v-loading="isLoading || isRendering"
      >
        <div
          class="cs-sign flex justify-between items-center py-2 px-4 gap-4 mb-2"
        >
          <div class="fs-20 font-bold uppercase text-white">
            {{ getEnvelopeNameByType(documentType) }}
          </div>

          <div class="flex gap-2">
            <!-- <el-select
              v-model="selectedProcedure"
              placeholder="Chọn Quy trình ký"
              value-key="id"
            >
              <el-option
                v-for="item in procedures"
                :key="item.id"
                :label="item.procedure_name"
                :value="item"
              >
              </el-option>
            </el-select> -->
            <el-button
              class="fs-16 ml-2"
              size="small"
              plain
              type="primary"
              :disabled="isLoading || isRendering"
              @click="handleSendSignDocument"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 14 14"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m5.812 11l2.178 2.168a1.1 1.1 0 0 0 1.05.3a1.119 1.119 0 0 0 .809-.74l3.576-10.72A1.118 1.118 0 0 0 11.987.57L1.267 4.147a1.119 1.119 0 0 0-.74.859a1.099 1.099 0 0 0 .3 1l2.737 2.737l-.09 3.466zM13.106.79L3.564 8.742"
                />
              </svg>
              {{ $t("Trình Ký") }}</el-button
            >

            <el-button
              class="fs-16"
              size="small"
              plain
              type="primary"
              @click="handleClose"
              >{{ $t("Đóng") }}</el-button
            >
          </div>
        </div>
        <div class="text-black cs-menu">
          <div
            @click="isOpenSidebar = !isOpenSidebar"
            style="border: 1px solid #000"
            class="p-1 rounded mr-2 mb-2 cursor-pointer"
          >
            <svg
              class="cs-setting"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 7.50004C11.11 7.50004 10.2399 7.76396 9.49992 8.25843C8.75989 8.7529 8.18312 9.4557 7.84252 10.278C7.50193 11.1002 7.41281 12.005 7.58645 12.8779C7.76008 13.7509 8.18866 14.5527 8.818 15.182C9.44734 15.8114 10.2492 16.2399 11.1221 16.4136C11.995 16.5872 12.8998 16.4981 13.7221 16.1575C14.5443 15.8169 15.2471 15.2401 15.7416 14.5001C16.2361 13.7601 16.5 12.8901 16.5 12C16.4987 10.8069 16.0242 9.66308 15.1806 8.81943C14.3369 7.97579 13.1931 7.50128 12 7.50004ZM12 15C11.4066 15 10.8266 14.8241 10.3333 14.4945C9.83992 14.1648 9.45541 13.6963 9.22834 13.1481C9.00128 12.5999 8.94187 11.9967 9.05763 11.4148C9.17338 10.8328 9.4591 10.2983 9.87866 9.87872C10.2982 9.45916 10.8328 9.17344 11.4147 9.05769C11.9967 8.94193 12.5999 9.00134 13.148 9.2284C13.6962 9.45547 14.1647 9.83998 14.4944 10.3333C14.824 10.8267 15 11.4067 15 12C15 12.7957 14.6839 13.5588 14.1213 14.1214C13.5587 14.684 12.7956 15 12 15ZM20.25 12.2025C20.2537 12.0675 20.2537 11.9325 20.25 11.7975L21.6487 10.05C21.7221 9.95829 21.7728 9.85059 21.7969 9.73563C21.821 9.62067 21.8178 9.50165 21.7875 9.38817C21.5582 8.52623 21.2152 7.69865 20.7675 6.92723C20.7089 6.82628 20.6275 6.7404 20.5298 6.67644C20.4322 6.61248 20.3209 6.57219 20.205 6.55879L17.9812 6.31129C17.8887 6.21379 17.795 6.12004 17.7 6.03004L17.4375 3.80067C17.424 3.68462 17.3836 3.57332 17.3194 3.47566C17.2553 3.37801 17.1692 3.29668 17.0681 3.23817C16.2964 2.79131 15.4689 2.44864 14.6072 2.21911C14.4936 2.18891 14.3746 2.18583 14.2596 2.21009C14.1446 2.23435 14.037 2.28529 13.9453 2.35879L12.2025 3.75004C12.0675 3.75004 11.9325 3.75004 11.7975 3.75004L10.05 2.35411C9.95823 2.28076 9.85053 2.23 9.73557 2.2059C9.62061 2.1818 9.50159 2.18504 9.38811 2.21536C8.52631 2.44507 7.69878 2.78806 6.92717 3.23536C6.82622 3.29397 6.74034 3.37535 6.67638 3.473C6.61242 3.57065 6.57213 3.68189 6.55873 3.79785L6.31123 6.02535C6.21373 6.11848 6.11998 6.21223 6.02998 6.3066L3.80061 6.56254C3.68456 6.57604 3.57326 6.61647 3.4756 6.6806C3.37794 6.74473 3.29662 6.83079 3.23811 6.93192C2.79124 7.70363 2.44858 8.53114 2.21904 9.39286C2.18885 9.50641 2.18577 9.62547 2.21003 9.74044C2.23429 9.8554 2.28523 9.96306 2.35873 10.0547L3.74998 11.7975C3.74998 11.9325 3.74998 12.0675 3.74998 12.2025L2.35404 13.95C2.2807 14.0418 2.22994 14.1495 2.20584 14.2645C2.18174 14.3794 2.18498 14.4984 2.21529 14.6119C2.4446 15.4739 2.78761 16.3014 3.23529 17.0729C3.29391 17.1738 3.37529 17.2597 3.47294 17.3236C3.57059 17.3876 3.68183 17.4279 3.79779 17.4413L6.02154 17.6888C6.11467 17.7863 6.20842 17.88 6.30279 17.97L6.56248 20.1994C6.57598 20.3155 6.61641 20.4268 6.68054 20.5244C6.74467 20.6221 6.83073 20.7034 6.93186 20.7619C7.70357 21.2088 8.53108 21.5514 9.39279 21.781C9.50635 21.8112 9.62541 21.8143 9.74037 21.79C9.85534 21.7657 9.963 21.7148 10.0547 21.6413L11.7975 20.25C11.9325 20.2538 12.0675 20.2538 12.2025 20.25L13.95 21.6488C14.0417 21.7221 14.1494 21.7729 14.2644 21.797C14.3794 21.8211 14.4984 21.8179 14.6119 21.7875C15.4738 21.5582 16.3014 21.2152 17.0728 20.7675C17.1737 20.7089 17.2596 20.6275 17.3236 20.5299C17.3875 20.4322 17.4278 20.321 17.4412 20.205L17.6887 17.9813C17.7862 17.8888 17.88 17.795 17.97 17.7L20.1994 17.4375C20.3154 17.424 20.4267 17.3836 20.5244 17.3195C20.622 17.2554 20.7033 17.1693 20.7619 17.0682C21.2087 16.2965 21.5514 15.4689 21.7809 14.6072C21.8111 14.4937 21.8142 14.3746 21.7899 14.2596C21.7657 14.1447 21.7147 14.037 21.6412 13.9454L20.25 12.2025ZM18.7406 11.5932C18.7565 11.8642 18.7565 12.1359 18.7406 12.4069C18.7294 12.5925 18.7876 12.7755 18.9037 12.9207L20.234 14.5829C20.0814 15.068 19.8859 15.5386 19.65 15.9891L17.5312 16.2291C17.3467 16.2496 17.1764 16.3378 17.0531 16.4766C16.8726 16.6796 16.6804 16.8718 16.4775 17.0522C16.3386 17.1755 16.2505 17.3458 16.23 17.5304L15.9947 19.6472C15.5442 19.8833 15.0736 20.0788 14.5884 20.2313L12.9253 18.901C12.7922 18.7946 12.6269 18.7368 12.4565 18.7369H12.4115C12.1405 18.7529 11.8688 18.7529 11.5978 18.7369C11.4122 18.7257 11.2292 18.7839 11.084 18.9L9.41717 20.2313C8.93204 20.0786 8.46144 19.8832 8.01092 19.6472L7.77092 17.5313C7.75044 17.3468 7.66225 17.1764 7.52342 17.0532C7.32046 16.8727 7.12825 16.6805 6.94779 16.4775C6.82454 16.3387 6.65418 16.2505 6.46967 16.23L4.35279 15.9938C4.11672 15.5433 3.92126 15.0727 3.76873 14.5875L5.09904 12.9244C5.21521 12.7793 5.27334 12.5962 5.26217 12.4107C5.24623 12.1397 5.24623 11.8679 5.26217 11.5969C5.27334 11.4114 5.21521 11.2283 5.09904 11.0832L3.76873 9.41723C3.92138 8.9321 4.11684 8.4615 4.35279 8.01098L6.46873 7.77098C6.65325 7.7505 6.82361 7.66231 6.94686 7.52348C7.12732 7.32052 7.31952 7.12831 7.52248 6.94785C7.66187 6.82452 7.75042 6.65377 7.77092 6.46879L8.00623 4.35286C8.4567 4.11679 8.92731 3.92132 9.41248 3.76879L11.0756 5.0991C11.2207 5.21527 11.4038 5.2734 11.5894 5.26223C11.8604 5.24629 12.1321 5.24629 12.4031 5.26223C12.5887 5.2734 12.7717 5.21527 12.9169 5.0991L14.5828 3.76879C15.0679 3.92144 15.5385 4.1169 15.989 4.35286L16.229 6.46879C16.2495 6.65331 16.3377 6.82367 16.4765 6.94692C16.6795 7.12738 16.8717 7.31958 17.0522 7.52254C17.1754 7.66137 17.3458 7.74956 17.5303 7.77004L19.6472 8.00535C19.8832 8.45583 20.0787 8.92644 20.2312 9.4116L18.9009 11.0747C18.7836 11.2211 18.7254 11.406 18.7378 11.5932H18.7406Z"
                fill="#0C0C0D"
              />
            </svg>
          </div>
        </div>
        <div class="cs-box text-black">
          <div v-if="isOpenSidebar" class="cs-sidebar">
            <SettingSendSign
              :procedure="selectedProcedure"
              :signatories="signatories"
              :signatoryErrors="signatoryErrors"
              @onClose="isOpenSidebar = false"
              @onSelect="handleSelectSignatory"
            />
          </div>
          <div class="cursor-none cs-container">
            <div class="flex gap-8 justify-center relative">
              <div :id="containerID" class="pdf-container cs-cursor">
                <div v-for="(signatory, index) in signatories" :key="index">
                  <div
                    v-if="
                      signatory && (signatory.metadata || signatory.isSelected)
                    "
                  >
                    <img
                      v-if="signatory.signature_image"
                      class="cs-image-pdf"
                      :id="`${imageID}_${signatory.id}`"
                      :src="signatory.signature_image"
                      alt="Moving Image"
                      :width="imageX"
                      :height="imageY"
                    />
                    <div
                      v-else
                      :id="`${imageID}_${signatory.id}_default`"
                      class="cs-default-signature cursor-pointer"
                    >
                      <div class="flex gap-2 items-center justify-center">
                        <div class="rounded-full overflow-hidden">
                          <img
                            :src="getAvatar(signatory)"
                            width="30"
                            height="30"
                          />
                        </div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="currentColor"
                            d="M12.021 2.772a2.445 2.445 0 1 1 3.458 3.457L14.207 7.5l.086.086a2 2 0 0 1 0 2.829l-1.44 1.439a.5.5 0 0 1-.707-.707l1.44-1.44a1 1 0 0 0 0-1.414l-.086-.086l-6.646 6.647a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.595-.643l1.25-3.75a.5.5 0 0 1 .12-.195l8.626-8.625Zm2.75.707a1.445 1.445 0 0 0-2.042 0L4.187 12.02l-.925 2.774l2.982-.745l8.527-8.527a1.445 1.445 0 0 0 0-2.043ZM3.217 16.867l.051.038C4.011 17.445 5.112 18 6.5 18c.743 0 1.424-.26 2.029-.604c.603-.344 1.163-.79 1.661-1.195l.117-.095c.464-.378.862-.701 1.228-.917c.403-.238.644-.268.807-.214c.265.088.416.293.679 1.169c.087.292.243.61.471.867c.229.257.569.49 1.008.49c.474 0 .943-.229 1.305-.442c.239-.141.495-.318.703-.46c.103-.07.193-.133.264-.18c.268-.173.494-.285.649-.353c.077-.034.136-.057.174-.07l.04-.014l.006-.002a.5.5 0 0 0-.281-.96h-.001l-.003.002l-.007.002l-.021.007l-.07.023a3.57 3.57 0 0 0-.24.096a5.602 5.602 0 0 0-.79.43c-.117.077-.23.154-.342.232a9.27 9.27 0 0 1-.589.385c-.341.202-.61.303-.797.303c-.06 0-.15-.03-.26-.154a1.34 1.34 0 0 1-.261-.49c-.24-.8-.5-1.556-1.32-1.83c-.588-.196-1.16.023-1.632.301c-.435.257-.892.63-1.337.992l-.13.106c-.502.407-1.004.804-1.526 1.102c-.52.296-1.027.473-1.534.473c-.746 0-1.396-.2-1.934-.47l-1.349.337ZM17.5 15.5l-.14-.48l.14.48Z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <vue-pdf-embed
                  :ref="elementID"
                  :id="elementID"
                  :source="urlPDF"
                  @internal-link-clicked="handleClickedPage"
                  @loaded="handleDocumentLoad"
                  @rendered="handleDocumentRender"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
      
  <script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import SignatureRequest from '@/api/request/SignatureRequest'
import {
  ENVELOPE_DOCUMENT_TYPE,
  ENVELOPE_TYPE,
  SIGNATORY_ROLE
} from '../../utils/constants'
import SettingSendSign from './SettingSendSign.vue'
import appUtils from '../../utils/appUtils'
import avatarDefault from '../../assets/images/avatar.png'
import uploadS3File from '../../utils/uploadS3File'

export default {
  name: 'ModalSendSign',
  components: { VuePdfEmbed, SettingSendSign },
  props: {
    elementIDProps: {
      type: String,
      required: true
    },
    containerIDProps: {
      type: String,
      required: true
    },
    imageIDProps: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      pageCount: null,
      signatureImage: '',
      isRendering: true,
      imageX: 80,
      imageY: 40,
      urlPDF: '',
      documentPDFViewer: null,
      metadata: null,
      documentType: null,
      isUseSignProcedure: false,
      procedures: [],
      selectedProcedure: null,
      signerID: null,
      documentID: null,
      envelopeSignatories: [],
      containerID: 'ContainerSendSignPDF',
      elementID: 'SendSignPDF',
      imageID: 'SendSignImageID',
      isOpenSidebar: true,
      selectedSignatory: null,
      canvasEventHandlers: new Map(),
      signatoryErrors: [],
      avatarDefault
    }
  },
  computed: {
    request () {
      return new SignatureRequest()
    },
    signatories () {
      const signNodes = this.selectedProcedure?.sign_nodes || []
      const allSignatories = signNodes?.reduce((acc, signNode) => {
        return [...acc, ...(signNode?.node_signatories || [])]
      }, [])

      return (
        allSignatories?.sort((a, b) => a?.sign_order - b?.sign_order) || []
      )
    }
  },
  watch: {
    elementIDProps () {
      this.elementID = this.elementIDProps || 'SendSignPDF'
    },
    containerIDProps () {
      this.containerID = this.containerIDProps || 'ContainerSendSignPDF'
    },
    imageIDProps () {
      this.imageID = this.imageIDProps || 'SendSignImageID'
    }
  },
  created () {
    this.elementID = this.elementIDProps || 'SendSignPDF'

    this.containerID = this.containerIDProps || 'ContainerSendSignPDF'
    this.imageID = this.imageIDProps || 'SendSignImageID'
  },
  mounted () {
    // this.handleCheckMouseInPage()
  },
  methods: {
    handleClose () {
      this.handleClearEvent()

      this.urlPDF = ''
      this.documentPDFViewer = null
      this.metadata = null
      this.selectedSignature = {}
      this.envelopeSignatories = []
      this.selectedProcedure = null
      this.signerID = null
      this.documentID = null
      this.documentType = null
      this.isUseSignProcedure = false
      this.isOpen = false
      this.procedures = []
      this.selectedProcedure = null
      this.selectedSignatory = null

      this.$emit('onClose')
    },
    handleOpen (url, docType, documentID, procedure) {
      this.isOpen = true
      this.urlPDF = url
      this.documentType = docType
      this.documentID = documentID
      this.isOpenSidebar = true
      this.isRendering = true
      this.isUseSignProcedure = Boolean(procedure)

      const procedureResult = this.handleProcessProcedureData(procedure)
      this.selectedProcedure = procedureResult
      // this.getSignProcedures()

      //   this.handleProcessSignProcedure(procedure);
    },
    async handleSubmit () {},
    handleDocumentLoad (documentPDF) {
      this.pageCount = documentPDF.numPages
      this.documentPDFViewer = documentPDF
    },
    handleDocumentRender () {
      if (!this.isRendering) return
      this.handleSelectSignatory(this.signatories?.[0])
      // this.handleCheckMouseInPage()
      this.isRendering = false
    },
    handleClickedPage (page) {
      console.log('clicked link', page)
    },
    handleAddEventForCanvas () {
      if (!this.selectedSignatory) return

      const container = document.getElementById(this.containerID)
      const canvases = container?.querySelectorAll('canvas')
      const self = this
      // Store the event handlers in a Map, using the canvas element as the key

      const containerHandler = function (e) {
        self.handleMoveImage(e, container)
      }
      container.addEventListener('mousemove', containerHandler)
      self.canvasEventHandlers.set(container, containerHandler)

      // When adding the event listener, store the handler function in the Map
      canvases.forEach((item, index) => {
        const handler = function (event) {
          self.handleCalcPositionSignature(item, event, index + 1)
        }
        item.addEventListener('mousedown', handler)
        self.canvasEventHandlers.set(item, handler)
      })
    },
    handleMoveImage (e, container) {
      const self = this

      self.signatories.forEach((signatory) => {
        const imageID = `${self.imageID}_${signatory?.id}`

        const image = document.getElementById(imageID)
        const imageDefault = document.getElementById(`${imageID}_default`)

        if (
          this.selectedSignatory?.id !== signatory?.id ||
          this.selectedSignatory?.metadata ||
          !this.selectedSignatory?.isSelected
        ) {
          return
        }

        const mouseX = e.clientX - container.getBoundingClientRect().left
        const mouseY = e.clientY - container.getBoundingClientRect().top

        if (image) {
          image.style.left = mouseX + 'px'
          image.style.top = mouseY + 'px'
        }

        if (imageDefault) {
          imageDefault.style.left = mouseX + 'px'
          imageDefault.style.top = mouseY + 'px'
        }
      })
    },
    async handleCalcPositionSignature (canvas, event, page) {
      const self = this
      const pageViewer = await this.getPDFPageViewer(page)

      const imageX = this.imageX
      const imageY = this.imageY

      // Lấy kích thước của canvas
      var rect = canvas.getBoundingClientRect()

      // Tính toán tọa độ x, y của chuột trên canvas
      var x = event.clientX - rect.left
      var y = event.clientY - rect.top

      // Tính toán tọa độ trên PDF từ tọa độ chuột trên canvas
      var viewport = pageViewer.getViewport({ scale: 1.0 })
      var pdfX = (x / rect.width) * viewport.width
      var pdfY = (y / rect.height) * viewport.height
      const pointY = parseInt(viewport.height - pdfY)
      const pointX = pdfX

      const llX = parseInt(pointX - imageX / 2) + 10
      const llY = parseInt(pointY - imageY / 2) + 10
      const urX = parseInt(pointX + imageX / 2) - 5
      const urY = parseInt(pointY + imageY / 2)
      const viewLLY = parseInt(y - this.imageY / 2)
      const viewURY = parseInt(y + this.imageY / 2)
      const viewLLX = parseInt(x - this.imageX / 2)
      const viewURX = parseInt(x + this.imageX / 2)

      const nodes = this.selectedProcedure?.sign_nodes?.map((node) => {
        const signatories = node?.node_signatories?.map((sign) => {
          // Check if the signature is clicked
          const isClickedSignature = sign?.metadata
            ? pointX >= sign?.metadata?.llX &&
              pointX <= sign?.metadata?.urX &&
              pointY >= sign?.metadata?.llY &&
              pointY <= sign?.metadata?.urY &&
              page === sign?.metadata?.page
            : true

          if (sign?.isSelected && isClickedSignature) {
            if (!sign?.metadata) {
              const metadata = {
                llX,
                llY,
                urX,
                urY,
                page,
                viewLLY,
                viewURY,
                viewLLX,
                viewURX,
                pointX: x,
                pointY: y
              }

              self.selectedSignatory = { ...self.selectedSignatory, metadata }
              self.signatoryErrors = self.signatoryErrors.filter(
                (item) => item !== sign?.id
              )
              return { ...sign, metadata }
            } else {
              self.selectedSignatory = {
                ...self.selectedSignatory,
                metadata: null
              }

              return { ...sign, metadata: null }
            }
          } else {
            return sign
          }
        })
        return { ...node, node_signatories: signatories }
      })

      this.selectedProcedure = {
        ...this.selectedProcedure,
        sign_nodes: nodes
      }
    },
    async getPDFPageViewer (pageNum) {
      const pageViewer = await this.documentPDFViewer.getPage(pageNum)
      return pageViewer
    },

    generateImageSrcBase64 (content) {
      var prefix = 'data:image/png;base64,'

      return prefix + content
    },
    getEnvelopeNameByType () {
      switch (this.documentType) {
        case ENVELOPE_DOCUMENT_TYPE.EXAMINATION:
          return 'Phiếu khám bệnh'

        case ENVELOPE_DOCUMENT_TYPE.PRESCRIPTION:
          return 'Đơn thuốc'

        case ENVELOPE_DOCUMENT_TYPE.INDICATION_RESULT:
          return 'Kết quả chỉ định'

        case ENVELOPE_DOCUMENT_TYPE.SURGERY_FORM:
          return 'Phiếu phẫu thuật/thủ thuật'

        case ENVELOPE_DOCUMENT_TYPE.TREATMENT_FORM:
          return 'Phiếu điều trị'

        case ENVELOPE_DOCUMENT_TYPE.CARE_FORM:
          return 'Phiếu chăm sóc'

        case ENVELOPE_DOCUMENT_TYPE.NUTRITIONAL_FORM:
          return 'Phiếu đánh giá dinh dưỡng'

        case ENVELOPE_DOCUMENT_TYPE.CONFIRM_TREATMENT:
          return 'Phiếu xác nhận điều trị'

        case ENVELOPE_DOCUMENT_TYPE.SUMMARY_TREATMENT_FORM:
          return 'Phiếu sơ kết điều trị'

        case ENVELOPE_DOCUMENT_TYPE.MDT_FORM:
          return 'Biên bản hội chẩn'

        default:
          return ''
      }
    },

    async getSignProcedures () {
      if (!this.documentType) return
      try {
        const params = {
          page_num: 1,
          page_size: 1000,
          order: 'desc',
          sort_by: 'id',
          document_type: this.documentType,
          ws_id: this.$globalClinic?.id
        }

        const request = new SignatureRequest()

        const response = await request.getSignProcedures(params)

        this.procedures = response.data?.data || []
        this.selectedProcedure = this.procedures?.[0]
      } catch (error) {
        console.log(error)
      }
    },
    handleSelectSignatory (signatory) {
      this.handleClearEvent()

      this.selectedSignatory = signatory
      this.selectedProcedure.sign_nodes.forEach((node) => {
        node.node_signatories.forEach((sign) => {
          sign.isSelected = sign?.id === signatory?.id
        })
      })

      this.$nextTick(() => {
        this.handleAddEventForCanvas()
      })

      if (signatory.metadata) {
        // Scroll to signature
        const image = document.getElementById(
          `${this.imageID}_${signatory.id}_default`
        )

        if (image) {
          image.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          })
        }
      }
    },
    handleProcessProcedureData (procedure) {
      const formatSignNodes = procedure?.sign_nodes?.map((node) => {
        const signatories = node?.node_signatories?.map((signatory, index) => {
          return {
            ...signatory,
            isSelected: index === 0
          }
        })

        return {
          ...node,
          node_signatories: signatories
        }
      })

      return { ...procedure, sign_nodes: formatSignNodes }
    },
    handleClearEvent () {
      const self = this
      const container = document.getElementById(this.containerID)
      const canvases = container?.querySelectorAll('canvas')

      if (self.canvasEventHandlers) {
        const containerHandler = self.canvasEventHandlers.get(container)
        if (containerHandler) {
          container.removeEventListener('mousemove', containerHandler)
          self.canvasEventHandlers.delete(container)
        }

        canvases.forEach((item) => {
          const handler = self.canvasEventHandlers.get(item)
          if (handler) {
            item.removeEventListener('mousedown', handler)
            self.canvasEventHandlers.delete(item)
          }
        })
      }
    },
    getAvatar (signatory) {
      if (!signatory?.user?.avatar) return avatarDefault

      return appUtils.getImageURL(signatory?.user?.avatar)
    },
    async handleSendSignDocument () {
      if (this.isLoading || this.isRendering) return

      try {
        this.isLoading = true
        this.handleValidateDocument()

        const isValidDocument = this.signatoryErrors.length === 0
        if (!isValidDocument) return

        const { envelopeUrl, documentBase64 } =
          await this.handleProcessDocument()
        if (!envelopeUrl || !documentBase64) return

        const responseEnvelope = await this.handleCreateEnvelope(envelopeUrl)

        if (!responseEnvelope || !responseEnvelope?.id) {
          return
        }

        const params = {
          envelope_id: responseEnvelope.id,
          sign_url: `${window.location.origin}/#/sign-envelope/${responseEnvelope.id}`
        }
        await this.request.sendNotiSignDocument(params)

        this.$toast.open({
          type: 'success',
          message: this.$t('Trình ký thành công')
        })
        this.handleClose()
        this.$emit('onSuccess')
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    handleValidateDocument () {
      this.selectedProcedure.sign_nodes.forEach((node) => {
        node.node_signatories.forEach((signatory) => {
          this.checkCompletedSignatory(signatory)
        })
      })
    },
    checkCompletedSignatory (signatory) {
      const isSelectedPosition = [
        signatory?.metadata?.llX,
        signatory?.metadata?.llY,
        signatory?.metadata?.urX,
        signatory?.metadata?.urY
      ].every((item) => item)

      if (!isSelectedPosition) {
        this.$toast.open({
          type: 'warning',
          message: this.$t(
            `Vui lòng chọn vị trí ký cho ${signatory?.user?.name}`
          )
        })
        this.signatoryErrors.push(signatory.id)
        // return false
      }

      // const hasEmail = signatory?.user?.email

      // if (!hasEmail) {
      //   this.$toast.open({
      //     type: 'warning',
      //     message: this.$t(`Không tìm thấy email của ${signatory?.user?.name}`)
      //   })
      //   this.signatoryErrors.push(signatory.id)
      //   // return false
      // }

      // return isSelectedPosition && signatory?.id && hasEmail
    },
    async handleProcessDocument () {
      try {
        const newImageSrc = new URLSearchParams(this.urlPDF).toString()
        const formatImageSrc = newImageSrc.substring(0, newImageSrc.length - 1)
        const responseImage = await this.$rf
          .getRequest('DoctorRequest')
          .postUrlImage(formatImageSrc)
        const base64File = responseImage.data?.data || ''

        const [envelopeUrl] = await this.handleUploadFilesAWS(base64File)

        return { envelopeUrl, documentBase64: base64File }

        // return base64File
      } catch (error) {
        console.log(error)
      }
    },
    async handleCreateEnvelope (documentUrl) {
      try {
        const envelopeSignatories = this.handleProcessEnvelopSignatories()

        const params = {
          sign_procedure_id: this.selectedProcedure?.id,
          document_id: this.documentID,
          document_type: this.documentType,
          document_url: documentUrl,
          envelope_name: this.getEnvelopeNameByType(this.documentType),
          // document_base64: documentUrl,
          envelope_description: '',
          envelope_type: ENVELOPE_TYPE.SEND_SIGN,
          issuer: this.$user?.id,
          issuer_date: window.moment().valueOf(),
          envelope_signatories: envelopeSignatories
          // expired_date: '',
        }

        const response = await this.request.createEnvelope(params)

        if (response.status === 200) {
          return response.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleProcessEnvelopSignatories () {
      if (this.isUseSignProcedure) {
        const signatories = this.signatories?.map((item) => ({
          node_signatory_id: item?.id,
          user_id: item?.user_id,
          signatory_name: item?.user?.name,
          signatory_email: item?.user?.email,
          signatory_role: SIGNATORY_ROLE.signer,
          signatory_order: item?.sign_order,
          role_name: item?.role_name,
          is_required: item?.is_required,
          expired_date: item?.expired_date || undefined,
          metadata: {
            signature_id: item?.signature_id,
            signature_position_rectangle: [
              item.metadata.viewLLX,
              item.metadata.viewLLY,
              item.metadata.viewURX,
              item.metadata.viewURY
            ].join(','),
            signature_position_rectangle_pdf: [
              item.metadata.llX,
              item.metadata.llY,
              item.metadata.urX,
              item.metadata.urY
            ].join(','),
            signature_position_page: String(item.metadata.page)
          }
          // access_code: item?.node_signatory?.acc
        }))

        return signatories
      } else {
        // TODO: manual
        return []
      }
    },
    async handleUploadFilesAWS (base64) {
      if (!this.documentID) return

      const formatBase64 = 'data:application/pdf;base64,' + base64

      const file = appUtils.convertBase64tToFile(
        formatBase64,
        this.getEnvelopeNameByType(this.documentType)
      )

      const prefixPath = `resources/sign_envelopes/${this.documentType}/`

      const resultUrl = await uploadS3File.uploadHandler(
        this.documentID,
        window.moment().valueOf(),
        [file],
        1,
        prefixPath
      )

      return resultUrl?.map((item) => item?.url)
    }
  }
}
</script>
      
  <style lang="scss" scoped>
.vue-pdf-embed {
  margin: 0 auto;
}

.vue-pdf-embed__page {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}
.cs-container {
  overflow: auto;

  // pointer-events: none;
}

.pdf-container {
  width: 1000px;
  border: 1px solid #000;
  //   margin: 0 auto;
  position: relative;
}

::v-deep {
  .vue-pdf-embed {
    .vue-pdf-embed__page {
      margin-bottom: 8px;

      box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
    }
  }

  .cs-dialog {
    .el-dialog__header {
      padding: 0 !important;
    }

    .el-dialog__body {
      padding: 0 !important;
    }

    .el-input__inner {
      height: 42px !important;
    }
  }
}

.cs-image-pdf {
  position: absolute;
  z-index: 1000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  border: 1px dashed #696969;
  padding: 4px;
}

.cs-sign {
  position: sticky;
  top: 0px;
  right: 20px;
  background-color: rgb(74, 74, 74);
  z-index: 100000;
}

.cs-default-signature {
  position: absolute;
  z-index: 2000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  border: 1px dashed #696969;
  padding: 4px;
  width: 80px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffc820;
  cursor: pointer !important;
}

.cs-sidebar {
  background-color: white;
  width: 350px;
  height: 100vh;
  position: fixed;
  top: 60px;
  right: 0;
  z-index: 10000;
  // border: 1px solid #000;

  animation: fadeInRight 0.2s linear;
  transition: all 1s ease-in-out;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.cs-box {
  position: relative;
}

.cs-menu {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  z-index: 10000;
}

@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.cs-setting {
  animation: rotating 2s linear infinite;
}
</style>